const PostProcessingShader = {

	name: 'PostProcessingShader',

	uniforms: {

		'tDiffuse': { value: null },
		'opacity': { value: 1.0 },
      'brightness': { type: 'f', value: 1.0},
      'saturation': { type: 'f', value: 1.0},
      'hue': { type: 'f', value: 0.0}

	},

	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

		uniform float opacity;

		uniform sampler2D tDiffuse;

        uniform float brightness;
        uniform float saturation;
        uniform float hue;

		varying vec2 vUv;

        vec3 rgb2hsv(vec3 c)
        {
            vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
            vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
            vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));
        
            float d = q.x - min(q.w, q.y);
            float e = 1.0e-10;
            return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
        }
        
        vec3 hsv2rgb(vec3 c)
        {
            vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
            vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
            return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
        }

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
            vec3 texelHsv = rgb2hsv(vec3(texel.r, texel.g, texel.b));
            vec3 texelFinal = hsv2rgb(vec3(texelHsv.r + hue, texelHsv.g  * saturation, texelHsv.b * brightness));
			gl_FragColor = vec4(texelFinal.r, texelFinal.g, texelFinal.b, texel.a) * opacity;
		}`

};

